angular.module('FmsApp').factory('GenusResource', function($resource) {
  return $resource('/api/genus/:id', { crop_name: '@search' });
});
